import { OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../core/services/authentication.service';
import { HeaderService } from './header.service';
import { AppSelectorService } from '../../shared/services/app-selector/app-selector.service';
import { DatacontextService } from '../../data/datacontext.service';
import { TrialUserService } from 'src/app/shared/services/trial-user/trial-user.service';
import { AmplitudeLoggerService } from 'src/app/shared/services/amplitude-logger/amplitude-logger.service';
import { FeatureListJsonService } from 'src/app/shared/services/config-manager/feature-list/feature-list-json.service';
import { UserInfoService } from 'src/app/shared/services/user-info/user-info.service';
import { AnalyticsEvents } from 'src/app/shared/constants/analytics-events';
import { SwitchPanelComponent } from '../switch-panel/switch-panel.component';
import { MatDialog } from '@angular/material';
import { AppSelectorComponent } from '../sidebar/app-selector/app-selector.component';
import { EnvironmentManagerService } from 'src/app/shared/services/environment-manager/environment-manager.service';
import { SettingsService } from 'src/app/data/repositories/settings/settings.service';
import { cloneDeep } from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import moment from 'moment';
var HeaderComponent = /** @class */ (function () {
    function HeaderComponent(authentication, headerService, router, userInfo, appSelectorService, datacontextService, trialUserService, amplitudeLoggerService, featureListJsonService, dialog, environmentManagerService, settingsService) {
        var _this_1 = this;
        this.authentication = authentication;
        this.headerService = headerService;
        this.router = router;
        this.userInfo = userInfo;
        this.appSelectorService = appSelectorService;
        this.datacontextService = datacontextService;
        this.trialUserService = trialUserService;
        this.amplitudeLoggerService = amplitudeLoggerService;
        this.featureListJsonService = featureListJsonService;
        this.dialog = dialog;
        this.environmentManagerService = environmentManagerService;
        this.settingsService = settingsService;
        this.companyDetails = { name: '' };
        this.userData = {
            name: '',
            email: ''
        };
        this.headerData = {
            title: '',
            breadCrumb: []
        };
        this.tabs = [
            {
                name: 'All',
                value: 'All',
            }, {
                name: 'android',
                value: 'Android',
                icon: 'android'
            }, {
                name: 'ios',
                value: 'iOS',
                icon: 'apple'
            }, {
                name: 'web',
                value: 'Web',
                icon: 'desktop_windows'
            }
        ];
        this.clonedAppList = [];
        this.selectedTabIndex = 0;
        this.appListMap = {};
        this.clonedAppListMap = {};
        // public allFecthData
        this.tabIndexLabelMap = {
            1: 'android',
            2: 'ios',
            3: 'web'
        };
        this.listSubHeader = {
            android: 'ANDROID',
            ios: 'iOS',
            web: 'WEB'
        };
        // public appListMap = [];
        this.settingMenuItem = [
            {
                featureName: 'apps',
                hide: false,
                section: 'apps',
                text: 'Apps',
                img: 'assets/images/app.svg'
            },
            // {
            //   featureName: 'data_sources',
            //   hide: false,
            //   section: 'ds',
            //   text: 'Data Sources'
            // },
            {
                featureName: 'user_management',
                hide: false,
                section: 'users',
                text: 'User Management',
                img: 'assets/images/all_users.svg'
            },
            {
                featureName: 'activity_logs',
                hide: false,
                section: 'activity-logs',
                text: 'Activity Logs',
                img: 'assets/images/Logs.svg'
            },
        ];
        this.profileSettings = {
            profile: {
                pathString: 'user_settings.profile_settings',
                hide: false,
            }
        };
        this.subHeaderData = {
            label: [],
            selectedTab: 0
        };
        this.istrialUser = false;
        this.objectKeys = Object.keys;
        this.shouldShowMenu = false;
        this.appMap = {
            production: [],
            stage: []
        };
        this.ngUnsubscribe = new Subject();
        var _this = this;
        _this.selectedApp = _this.appSelectorService.getSelectedApp();
        _this.appSelectorService.getAppChangedListener().subscribe(function (selectedApp) {
            _this.selectedApp = selectedApp;
            _this.shouldSettingMenuBeHidden();
            _this.shouldProfileSettingBeHidden();
        });
        // Subscribed to header data change event
        this.headerService.getHeaderEmitter().subscribe(function (_data) {
            setTimeout(function () {
                if (_data.selectedApp) {
                    _this.selectedApp = _data.selectedApp;
                    delete _data.selectedApp;
                }
                else {
                    _this.selectedApp = _this.appSelectorService.getSelectedApp();
                }
                _this.headerData = _data;
            });
        });
        // Subscribed to sub-header data change event
        this.headerService.getSubheaderEmitter().subscribe(function (_data) {
            setTimeout(function () {
                _this.subHeaderData = _data;
            });
        });
        // Subscribed to profile data change event
        this.headerService.getProfileChangeEmitter().subscribe(function (_data) {
            setTimeout(function () {
                _this.userData.name = _data.name;
            });
        });
        this.environmentManagerService.getEnvironmentChangedListener().subscribe(function (env) {
            _this_1.boot();
        });
        this.appSelectorService.getAppsLoaded().subscribe(function (appId) {
            _this_1.boot(appId);
        });
    }
    HeaderComponent.prototype.shouldSettingMenuBeHidden = function () {
        var _this_1 = this;
        this.settingMenuItem.forEach(function (menu) {
            _this_1.featureListJsonService.shouldEnableTheFeature("account_settings." + menu.featureName + ".cta", 'hidden', function (flag) { return menu.hide = flag; });
        });
    };
    HeaderComponent.prototype.shouldProfileSettingBeHidden = function () {
        var _this_1 = this;
        var _loop_1 = function (key) {
            // tslint:disable-next-line: max-line-length
            this_1.featureListJsonService.shouldEnableTheFeature("" + this_1.profileSettings[key]['pathString'], 'hidden', function (flag) { return _this_1.profileSettings[key]['hide'] = flag; });
        };
        var this_1 = this;
        for (var key in this.profileSettings) {
            _loop_1(key);
        }
    };
    HeaderComponent.prototype.ngOnInit = function () {
        var _this_1 = this;
        this.appSelectorService.toggleAppDropdown$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(function () {
            if (_this_1.shouldShowMenu) {
                _this_1.shouldShowMenu = false;
            }
        });
        this.groupItems();
        // this.getAppListByAppState();
        this.shouldSettingMenuBeHidden();
        this.shouldProfileSettingBeHidden();
        this.userInfo.getUserData()
            .then(function (data) { return _this_1.email = data.email; });
        var _this = this;
        this.trialUserData = this.trialUserService.trialUserData;
        _this.getUserInfo();
        _this.getCompanyInfo();
        _this.router.events.subscribe(function (val) {
            if (val.url && !(val.url.includes('noResetSubHeader'))) {
                _this.resetSubHeaderData();
            }
            if (val.url && !(val.url.includes('noResetHeader'))) {
                _this.resetHeaderData();
            }
        });
    };
    HeaderComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    HeaderComponent.prototype.logout = function () {
        this.amplitudeLoggerService.resetUser();
        this.authentication.logout();
    };
    HeaderComponent.prototype.trackClick = function (event, cta, eventData) {
        this.amplitudeLoggerService.log(event, cta, eventData);
    };
    HeaderComponent.prototype.handlePlanClick = function () {
        var eventName = AnalyticsEvents.eventName, eventAction = AnalyticsEvents.eventAction;
        var planViewCta = '';
        var planClickCta = '';
        switch (this.companyDetails.plan) {
            case 'user_onboarding':
                planViewCta = eventAction.ONBOARD;
                planClickCta = eventAction.HANSEL_ONBOARD;
                break;
            case 'pro':
                planViewCta = eventAction.PRO;
                planClickCta = eventAction.HANSEL_OPTIMIZE;
                break;
            case 'advanced':
                planViewCta = eventAction.ADVANCED;
                planClickCta = eventAction.HANSEL_OPTIMIZE;
                break;
        }
        this.trackClick(eventName.BILLING_PAGE_CLICK, planClickCta, {
            email: this.email,
            app_name: this.selectedApp.name
        });
        this.trackClick(eventName.BILLING_PLAN_VIEW, planViewCta, { email: this.email, company: this.companyDetails.name });
        if (this.companyDetails.plan === 'user_onboarding') {
            this.changeRoute('/settings', { 'section': 'billing' });
        }
    };
    HeaderComponent.prototype.onClickLabel = function (labelObj) {
        var _this_1 = this;
        if (labelObj.index < 0 || (labelObj.index === this.subHeaderData.selectedTab)) {
            return;
        }
        var labelData = this.subHeaderData.labels[labelObj.index];
        if (labelData.cb) {
            this.subHeaderData.selectedTab = labelObj.index;
            setTimeout(function () {
                _this_1.subHeaderData.selectedTab = 0;
            });
            return labelData.cb(labelData);
        }
        else if (labelData.href) {
            this.redirect(labelData);
        }
        else {
            this.headerService.triggerSubHeaderCallbackEvent('labelClk', labelData);
        }
    };
    HeaderComponent.prototype.onClickBackBtn = function (backBtnData) {
        this.headerService.triggerSubHeaderCallbackEvent('backBtnClk', backBtnData);
    };
    HeaderComponent.prototype.redirect = function (labelData) {
        if (labelData.queryParams) {
            this.router.navigate([labelData.href], { queryParams: labelData.queryParams });
        }
        else {
            this.router.navigate([labelData.href]);
        }
    };
    HeaderComponent.prototype.resetHeaderData = function () {
        this.headerData = {
            title: '',
            breadCrumb: []
        };
    };
    HeaderComponent.prototype.resetSubHeaderData = function () {
        this.subHeaderData = {
            label: [],
            selectedTab: 0
        };
    };
    HeaderComponent.prototype.ifBackBtnPresent = function () {
        return (this.subHeaderData.labels &&
            this.subHeaderData.labels.length &&
            this.subHeaderData.labels[0].icon &&
            (this.subHeaderData.labels[0].icon === 'arrow_back'));
    };
    HeaderComponent.prototype.getUserInfo = function () {
        var _this_1 = this;
        this.datacontextService.user.getUserInfo(function (res) {
            _this_1.userData = res.api_response;
        });
    };
    HeaderComponent.prototype.getCompanyInfo = function () {
        var _this_1 = this;
        this.datacontextService.user.getUserCompany(function (res) {
            var _companyDetails = res.api_response.companies[0];
            delete _companyDetails.apps;
            _this_1.companyDetails = _companyDetails;
        });
    };
    HeaderComponent.prototype.changeRoute = function (url, queryParmas) {
        var _this_1 = this;
        this.router.navigate([url], { queryParams: queryParmas }).catch(function (err) {
            // Handle here
            window.history.pushState({}, document.title, url + '?' + (queryParmas ? _this_1.serialize(queryParmas) : ''));
            window.location.reload();
        });
    };
    HeaderComponent.prototype.serialize = function (obj) {
        var str = [];
        for (var p in obj) {
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
            }
        }
        return str.join('&');
    };
    HeaderComponent.prototype.isHomeButtonPresent = function () {
        return (!this.headerData.homeBtnCb && !this.headerData.disableHeader) || (this.headerData.homeBtnCb && !this.headerData.disableHeader);
    };
    HeaderComponent.prototype.getPaddingLeftValue = function () {
        if (this.headerData.hasOwnProperty('activityLogs') || this.headerData.isOverviewPage) {
            return '0';
        }
        if (this.isHomeButtonPresent()) {
            return '5em';
        }
        return '0';
    };
    HeaderComponent.prototype.openSwitchPanelDialog = function () {
        var _this_1 = this;
        var panelClass = ['switch-panel-dialog', 'no-padding', 'white-bg', 'animate__animated', 'animate__slideInLeft'];
        this.switchPanelRef = this.dialog.open(SwitchPanelComponent, {
            panelClass: panelClass,
            maxHeight: "100vh",
            maxWidth: "100vw",
            height: "100%",
            disableClose: true
        });
        this.switchPanelRef.backdropClick().subscribe(function () {
            document.getElementsByClassName("animate__animated")[0].classList.remove("animate__slideInLeft");
            document.getElementsByClassName("animate__animated")[0].classList.add("animate__slideOutLeft");
            setTimeout(function () { _this_1.switchPanelRef.close(); }, 1000);
        });
    };
    HeaderComponent.prototype.getFormattedDate = function (date) {
        return moment(date, 'x').format('MMM DD, YYYY hh:mm a');
    };
    HeaderComponent.prototype.isNeverEndingJourneyDate = function (date) {
        try {
            var endDate = moment(date, 'x');
            if (endDate.year() === 2085) {
                return true;
            }
        }
        catch (e) {
            return false;
        }
        return false;
    };
    HeaderComponent.prototype.toggleMenu = function (event) {
        event.stopPropagation();
        this.shouldShowMenu = !this.shouldShowMenu;
    };
    HeaderComponent.prototype.boot = function (appId) {
        this.currentEnvironment = this.environmentManagerService.getCurrentEnvironment();
        this.setupApps(appId);
    };
    HeaderComponent.prototype.setupApps = function (appId) {
        var prodApps = this.appSelectorService.getApplist('production');
        var stageApps = this.appSelectorService.getApplist('stage');
        if (prodApps.length) {
            prodApps = this.getModifiedAppList(prodApps);
        }
        if (stageApps.length) {
            stageApps = this.getModifiedAppList(stageApps);
        }
        this.appMap.production = prodApps;
        this.appMap.stage = stageApps;
        if (appId) {
            this.selectAppWithAppId(appId);
        }
        else {
            this.setFirstSelectedApp();
        }
    };
    HeaderComponent.prototype.setFirstSelectedApp = function () {
        this.selectApp(this.appSelectorService.getSelectedApp(), 0);
    };
    HeaderComponent.prototype.selectAppWithAppId = function (appId) {
        var idx = this.getIdForEnvironment(appId, this.currentEnvironment);
        this.selectApp(this.appMap[this.currentEnvironment][idx], idx);
        this.clonedAppList = cloneDeep(this.appMap[this.currentEnvironment]);
        this.groupItems();
        this.populateJourneysList();
    };
    HeaderComponent.prototype.groupItems = function () {
        this.appListMap = this.clonedAppList.reduce(function (result, item) {
            var os = item.os;
            if (!result[os]) {
                result[os] = [];
            }
            result[os].push(item);
            return result;
        }, {});
        this.clonedAppListMap = cloneDeep(this.appListMap);
    };
    HeaderComponent.prototype.populateJourneysList = function () {
        this.appListMap = {};
        if (this.selectedTabIndex === 0) {
            this.appListMap = cloneDeep(this.clonedAppListMap);
        }
        else {
            var key = this.tabIndexLabelMap[this.selectedTabIndex];
            if (this.clonedAppListMap.hasOwnProperty(key)) {
                this.appListMap[key] = this.clonedAppListMap[key];
            }
        }
    };
    HeaderComponent.prototype.selectApp = function (app, idx, stage) {
        var _this_1 = this;
        if (stage === void 0) { stage = null; }
        if (this.selectedApp.app === app) {
            return;
        }
        this.selectedApp.app = app;
        this.selectedApp.index = idx;
        this.appSelectorService.setSelectedApp(app);
        if (app && app.id) {
            this.settingsService.getAppVersionDetails({ 'app_id': app.id, 'list_all': true }).subscribe(function (data) {
                if (data && !data['is_error'] && data['api_response'] && data['api_response'].hasOwnProperty('app_versions')) {
                    _this_1.settingsService.setAppAndSDKVersions(data['api_response']['app_versions']);
                }
            });
        }
        this.shouldShowMenu = false;
        this.searchText = '';
    };
    HeaderComponent.prototype.getIdForEnvironment = function (appId, environment) {
        var idx = this.appMap[environment].findIndex(function (app) {
            return app.id === appId;
        });
        return idx;
    };
    HeaderComponent.prototype.shouldClose = function (event) {
        this.shouldShowMenu = event;
    };
    HeaderComponent.prototype.getModifiedAppList = function (appList) {
        appList.map(function (app) {
            app.lowerCaseName = app.name.toLowerCase();
            return app;
        });
        return appList;
    };
    return HeaderComponent;
}());
export { HeaderComponent };
